import React from "react";
import PropTypes from "prop-types";
import apiAgent from "../../../app/api/apiAgent";
import { OMSButtonStyleL } from "../../../app/common/common-components/OMSButton";
import { toast } from "react-toastify";
import { MediaFileComponent } from "./MediaFileComponent";
import { MediaLinkComponent } from "./MediaLinkComponent";
import ConfirmationModalPopup from "../../../app/common/common-components/ModalPopups/ConfirmationModalPopup";
import sortable from "html5sortable/dist/html5sortable.es.js";

//const Compressor = require("compressorjs").Compressor;
import Compressor from "compressorjs";

export class MediaStepView extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    super_access: PropTypes.bool,
    officeSyncID: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.setState({
      confirmationModalProps: {
        showModal: false,
        isConfirmed: (result) => {},
        title: "",
        body: "",
      },
    });

    this.linkComponentRef = React.createRef();
    this.fileComponentRef = React.createRef();
  }

  getStateFromData = (data) => {
    //console.log("inside Media step getStateFromData, data=", data);
    return {
      Step: "Listing capture: Media",
      PropertyID: data.propertyID,
      Photos: data.photos,
      Files: data.files,
      Links: data.links,
      photo_expanded: true,
      ViewZoom: 100,
    };
  };

  componentDidMount() {
    //this.setState(this.getStateFromData(this.props.data));
    //console.log("inside Media step componentDidMount, data=", this.props.data);
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    for (var i = 0; i < photosLength; i++) {
      window.$("#js-grid").append(this.getPhotoHtml(this.state.Photos[i]));
      var placeholderClass = "media-img-box-placeholder media-img-box-placeholder-" + this.state.ViewZoom;
    }
    this.doBindSortable();
    this.setState(this.getStateFromData(this.props.data));
    //state = this.getStateFromData(this.props.data);
  }

  componentDidUpdate(prevProps, prevState) {
    this.setOrderText();
  }

  openCloseDeleteModal = (isOpen) => {
    let varConfirmationModalProps = this.state.confirmationModalProps;
    varConfirmationModalProps.showModal = isOpen;
    this.setState({ confirmationModalProps: varConfirmationModalProps });
  };

  showPopupAndDeleteOnConfirmation = (title, body, callback) => {
    let varConfirmationModalProps = {
      title,
      body,
      showModal: true,
      isConfirmed: (isConfirmed) => {
        if (isConfirmed) {
          callback();
        }
        this.openCloseDeleteModal(false);
      },
    };

    this.setState({ confirmationModalProps: varConfirmationModalProps });
  };

  doBindSortable = () => {
    var placeholderClass = "media-img-box-placeholder media-img-box-placeholder-" + this.state.ViewZoom;
    if (this.sortable === undefined) {
      this.sortable = sortable(".js-grid", {
        placeholderClass: placeholderClass,
      });
      this.sortable[0].addEventListener(
        "sortupdate",
        function (e) {
          var from = e.detail.origin.index;
          var to = e.detail.destination.index;
          var photos = this.state.Photos.slice(0);
          photos.splice(to, 0, photos.splice(from, 1)[0]);
          for (var i = 0; i < photos.length; i++) {
            photos[i].order = i + 1;
          }
          photos.sort(function (a, b) {
            return a.order - b.order;
          });
          this.setState({ Photos: photos, IsDirty: true });
        }.bind(this)
      );
    } else {
      sortable(".js-grid", {
        placeholderClass: placeholderClass,
      });
    }
  };

  getPhotoHtml = (item) => {
    var orderDisplayHtml = "";
    //console.log("inside getPhotoHtml, item=", item);
    if (this.props.super_access) orderDisplayHtml = '<span id="spanOrder' + item.photoID + '">' + item.order + ")</span> ";

    var photoHtml = "";
    photoHtml += '<div id="' + item.photoID + '" class="media-img-box media-img-box-' + this.state.ViewZoom + '">';
    photoHtml += '<a class="img-thumbnail img-thumbnail-photo">';
    photoHtml += '<img id="img' + item.photoID + '" class="img-view" data-id="' + item.photoID + '" data-degrees="0" src="' + item.dataUrl + '" alt="" />';
    photoHtml += '<div class="caption">';
    photoHtml +=
      '<label id="desc' +
      item.photoID +
      '" class="photo-description">' +
      orderDisplayHtml +
      (item.description == "" ? "no description added" : item.description) +
      "</label>";
    photoHtml += '<div class="photo-action pull-right">';

    photoHtml +=
      '<span style="cursor:pointer; margin-right:5px;"><i class="fa fa-rotate-right" data-for="rotate" data-clockwise="false" data-id="' +
      item.photoID +
      '" aria-hidden="true"></i></span>';
    photoHtml +=
      '<span style="cursor:pointer; margin-right:5px;"><i class="fa fa-rotate-left" data-for="rotate" data-clockwise="true" data-id="' +
      item.photoID +
      '" aria-hidden="true"></i></span>';

    photoHtml +=
      '<span style="cursor:pointer; margin-right:5px;"><i class="fa fa-edit" data-for="edit" data-id="' + item.photoID + '" aria-hidden="true"></i></span>';
    photoHtml +=
      '<span style="cursor:pointer; margin-right:5px;"><i class="fa fa-close" data-for="delete" data-id="' + item.photoID + '" aria-hidden="true"></i></span>';
    photoHtml += "</div>";
    photoHtml += "</div>";
    photoHtml += "</a>";
    photoHtml += "</div>";
    return photoHtml;
  };

  doSetFormData = async (data) => {
    //console.log("inside doSetFormData, files=", this.state.Files);

    await this.uploadFilesAndPhotos();
    const mediaData = {
      //MandateID: this.state.MandateID,
      //PropertyID: this.state.PropertyID,
      Photos: this.state.Photos.map((photoItem, i) => {
        var img = window.$("#img" + photoItem.photoID);
        return {
          PhotoID: photoItem.photoID.indexOf("NAP") != -1 ? "" : photoItem.photoID,
          DataUrl: photoItem.photoID.indexOf("NAP") != -1 ? img.attr("src") : "",
          Rotate: img.data("degrees"),
          PropertyID: photoItem.propertyID,
          FileName: photoItem.fileName,
          LatLong: photoItem.latLong,
          aiFileds: photoItem.aiFileds,
          Description: photoItem.description,
          Order: photoItem.order,
        };
      }),
      Links: this.state.Links.map((linkItem, i) => {
        return {
          LinkID: linkItem.linkID.indexOf("NAP") != -1 ? "" : linkItem.linkID,
          Link: linkItem.link,
          Description: linkItem.description,
          Order: linkItem.order,
        };
      }),
      Files: this.state.Files.map((fileItem, i) => {
        //console.log("in doSetFormData, fileItem=", fileItem);
        let fileID = fileItem.fileID;
        let index = fileID.indexOf("NAP");
        //console.log("in doSetFormData, index=", index, ", fileID=", fileID);
        return {
          //FileID: fileItem.FileID.indexOf("NAP") != -1 ? "" : fileItem.FileID,
          //fileItem.fileID: (fileItem.fileID.indexOf('NAP') != -1)?fileItem.file:null,
          FileID: fileItem.fileID,
          //File: fileItem.File,

          FileName: fileItem.fileName,
          Description: fileItem.description,
          Order: fileItem.order,
          StrIsNewFile: fileItem.isNewFile,
          FileIcon: "",
          //Size: "",
          Size: fileItem.file ? fileItem.file.size : fileItem.size,
          //...(fileItem.FileID.indexOf("NAP") != -1 ? {} : { [fileID]: fileItem.File }),
        };
      }),
    };

    let mediaJson = JSON.stringify(mediaData);
    data.append("MediaJson", mediaJson);
    //console.log("inside doSetFormData before adding file collection, this.state.Files=", this.state.Files);
    //data.append("fileCollection",this.state.Files);
    //console.log("inside doSetFormData, mediaJson=", mediaJson);
  };

  uploadFilesAndPhotos = async () => {
    // var files=this.state.Files.map((file)=>{
    //   return file.fileID.indexOf("NAP") != -1 ;
    // });

    //console.log("inside uploadFilesAndPhotos, files=", this.state.Files);

    let newFiles = this.state.Files.filter((file) => file.fileID.indexOf("NAP") != -1);
    let oldFiles = this.state.Files.filter((file) => file.fileID.indexOf("NAP") === -1);

    newFiles.forEach((file) => {
      file.isNewFile = "true";
    });
    oldFiles.forEach((file) => {
      file.isNewFile = "false";
    });

    // newFiles = newFiles.map((file) => {
    //   return {...newFiles, isNewFile: 'true'};
    // });

    // oldFiles = oldFiles.map((file) => {
    //   return {...oldFiles, isNewFile: 'false'};
    // });

    //console.log("inside uploadFilesAndPhotos, this.state.Files=", this.state.Files,"newFiles=",newFiles,"oldFiles=",oldFiles);

    var photos = this.state.Photos;
    //console.log("inside uploadFilesAndPhotos, photos=", photos, "files=", files);
    const photoNames = photos.map((photo) => photo.fileName);
    const fileNames = newFiles.map((file) => file.fileName);
    //const allNames = [...photoNames, ...fileNames];
    let presignedUrls = [];
    //console.log("inside uploadFilesAndPhotos, fileNames=", fileNames);

    try {
      let presignedUrls;
      if (fileNames.length!=0) {
        presignedUrls = await apiAgent.S3Helper.getPresignedUrls(fileNames, this.props.officeSyncID);
        //console.log("inside uploadFilesAndPhotos, response=", presignedUrls);
        //console.log("inside uploadFilesAndPhotos, files=", newFiles);
        newFiles.forEach((file) => {
        if (file) {
          var name = file.fileName;
          var jsonString = presignedUrls[name];
          var jsonObject = JSON.parse(jsonString);
          //console.log("inside uploadFilesAndPhotos,presignedUrls=", presignedUrls, "file=", file, "jsonObject=", jsonObject);
          file.fileName = jsonObject.objectKey;
          file.fileID = jsonObject.fileID;
          //file.Size=file.File.size;
          //file.Size=
          
          var url = jsonObject.url;
          
          this.uploadFile(file, url);
        }
      });
    }

      this.setState({ Files: [...oldFiles, ...newFiles] });
    } catch (error) {
      console.log("inside uploadFilesAndPhotos, error=", error);
    }

    //console.log("after uploadFilesAndPhotos, this.state.Files=", this.state.Files);
  };

  uploadFile = async (file, url) => {
    //console.log("inside uploadFile, file=", file.file, "url=", url);
    const options = {
      method: "PUT",
      headers: {
        "Content-Type": file.type,
      },
      body: file.file,
    };

    try {
      const response = await fetch(url, options);
      //console.log("inside uploadFile, response=", response);
      return response;
    } catch (error) {
      console.error("Error", error);
    }
  };

  doCheckFormData = (data) => {
    var result = { status: "error", message: "Fields are required." };
    var resultSuccess = { status: "success", message: "" };
    return resultSuccess;
  };

  doSetState = (data) => {
    //console.log("inside mediaStepview doSetState, data=", data);
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    this.setState(this.getStateFromData(data), function () {
      window.$("#js-grid").html("");
      for (var i = 0; i < photosLength; i++) {
        window.$("#js-grid").append(this.getPhotoHtml(this.state.Photos[i]));
      }
      this.doBindSortable();

      this.linkComponentRef.current.doSetState(this.state.Links);
      this.fileComponentRef.current.doSetState(this.state.Files);
    });
    //console.log("inside mediaStepview end of doSetState",this.state);
  };

  doGetState = () => {
    return this.state;
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleAddPhotosClick = (e) => {
    window.$("#uploadPhoto").click();
  };

  handleUploadFileChange = (e) => {
    //console.log("inside handleUploadFileChange", e.target.files);
    //var filesLength = this.state.Files ? this.state.Files.length : 0;

    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    var filesLength = files ? files.length : 0;
    //console.log("inside handleUploadFileChange, files=", files);
    var arrFiles = [];
    if (files !== undefined) {
      for (var i = 0; i < filesLength; i++) {
        if (!files[i].name.match(/.(jpg|jpeg|png|gif|bmp|svg)$/i)) toast.info("Only jpg/jpeg, png, gif, bmp and svg images are allowed!");
        else arrFiles[i] = files[i];
      }
    }
    //console.log("inside handleUploadFileChange, arrFiles=", arrFiles);
    this.setFiles2(arrFiles);
  };

  setFiles2 = (files) => {
    //console.log("inside setFiles2", files);
    //console.log("inside setFiles2", this.state.Files);
    //var filesLength = this.state.Files ? this.state.Files.length : 0;
    var filesLength = files ? files.length : 0;
    if (files != undefined && filesLength > 0) {
      this.setState({ Files: files }, function () {
        var file = this.state.Files[0];
        var fileSize = file.size / 1024; // in Kb

        //console.log('Original file size - ' + fileSize);

        var quality = 1;

        if (fileSize <= 500) quality = 1;
        else if (fileSize > 500 && fileSize <= 850) quality = 0.85;
        else if (fileSize > 850 && fileSize <= 1000) quality = 0.8;
        else if (fileSize > 1000 && fileSize <= 1500) quality = 0.75;
        else if (fileSize > 1500 && fileSize <= 2000) quality = 0.7;
        else if (fileSize > 2000 && fileSize <= 2750) quality = 0.65;
        else if (fileSize > 2750 && fileSize <= 3250) quality = 0.6;
        else if (fileSize > 3250 && fileSize <= 4250) quality = 0.55;
        else if (fileSize > 4250 && fileSize <= 5850) quality = 0.5;
        else if (fileSize > 5850 && fileSize <= 6500) quality = 0.45;
        else if (fileSize > 6500 && fileSize <= 9800) quality = 0.4;
        else quality = 0.38;

        //console.log('Quality - ' + quality);

        if (quality == 1) {
          this.onUploadFileReaderLoaded2(file);
        } else {
          new Compressor(file, {
            quality: quality,
            maxWidth: 1920,
            maxHeight: 1080,
            convertSize: 2500000,
            success: function (result) {
              this.onUploadFileReaderLoaded2(result);
            }.bind(this),
            error: function (err) {
              //console.log(err.message);
              this.onUploadFileReaderLoaded2(file);
            }.bind(this),
          });
        }
      });
    } else {
      this.setState({ Files: [] });
      window.$("#uploadPhoto").val("");
    }
  };

  onUploadFileReaderLoaded2 = async (file) => {
    //console.log("inside onUploadFileReaderLoaded2", file);
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;

    var reader = new FileReader();
    reader.onloadend = async function (e) {
      // Mark this function as async
      var files = this.state.Files;
      if (e.target.readyState == FileReader.DONE) {
        var photos = this.state.Photos;

        var photoItem = {
          photoID: "NAP1",
          fileName: "",
          latLong: "",
          aiFileds: "",
          description: "",
          order: 1,
          dataUrl: e.target.result,
        };

        if (photosLength > 0) {
          var maxOrder = Math.max.apply(
            Math,
            photos.map(function (o) {
              return o.order;
            })
          );
          photoItem.order = maxOrder + 1;
          photoItem.photoID = "NAP" + photoItem.order;
        }
        photos.push(photoItem);

        try {
          await this.TryToUploadDynamicPhotoUpload(photoItem);
        } catch (error) {
          console.error("Error uploading photo:", error);
        }

        this.setState({ Photos: photos, photo_expanded: true });
        window.$("#js-grid").append(this.getPhotoHtml(photoItem));
        this.doBindSortable();
      }
      files = files.slice(1);
      this.setFiles2(files);
    }.bind(this);
    reader.readAsDataURL(file);
  };

  TryToUploadDynamicPhotoUpload = async (photoItem) => {
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    //console.log("before apiAgent.Property.SavePropertyPhotoSpeedUpAjax, photoItem=", photoItem);

    var data = new FormData();
    data.append("fileName", photoItem.fileName);
    data.append("fileBase64String", photoItem.dataUrl);

    const formDataObj = Object.fromEntries(data.entries());

    apiAgent.Property.SavePropertyPhotoSpeedUpAjax(formDataObj)
      .then((response) => {
        //console.log("after apiAgent.Property.SavePropertyPhotoSpeedUpAjax, response=", response);
        var photos = this.state.Photos;
        for (var i = 0; i < photosLength; i++) {
          if (photos[i].photoID == photoItem.photoID) {
            // find photo item and update
            photos[i].photoID2 = photos[i].photoID;
            photos[i].photoID = response.photoID;
            photos[i].fileName = response.fileName;
            photos[i].aiFileds = "speedup";
            this.setState({ Photos: photos });
            break;
          }
        }
      })
      .catch((error) => {
        toast.info("Fail");
      });
  };

  handleOnMainPhotoContainerClick = (e) => {
    if (e.target.tagName.toLowerCase() === "i") {
      if (e.target.dataset !== undefined && e.target.dataset.for !== undefined && e.target.dataset.id !== undefined) {
        if (e.target.dataset.for == "delete") this.handleRemoveFileClick(e.target.dataset.id);
        else if (e.target.dataset.for == "edit") this.handleEditFileClick(e.target.dataset.id);
        else if (e.target.dataset.for == "rotate") this.onRotateImageClick(e.target.dataset.id, e.target.dataset.clockwise);
      }
    } else if (e.target.tagName.toLowerCase() === "img") {
      if (e.target.dataset !== undefined && e.target.dataset.id !== undefined) {
        this.onViewPhoto(e.target.dataset.id);
      }
    }
  };
  onViewPhoto = (id) => {
    var photoItem = this.selectPhotoByID(id);
    if (photoItem != null) {
      if (photoItem.photoID.indexOf("NAP") != -1) {
        var img = document.getElementById("imgPre");
        img.className = "imgPre";
        img.src = window.$("#img" + photoItem.photoID).attr("src");
        window.$("#ImageModal1").modal("show");
      } else {
        var degrees = window.$("#img" + photoItem.photoID).data("degrees");
        if (degrees == 90 || degrees == -90 || degrees == 270 || degrees == -270) {
          var img = document.getElementById("imgPre2");
          img.className = "imgPre img-preview-view rotate" + degrees;
          img.src = photoItem.dataUrl.replace("net/b/t_", "net/b/f_");
          window.$("#ImageModal2").modal("show");
        } else {
          var img = document.getElementById("imgPre");
          img.className = "imgPre img-preview-view rotate" + degrees;
          img.src = photoItem.dataUrl.replace("net/b/t_", "net/b/f_");
          window.$("#ImageModal1").modal("show");
        }
      }
    }
  };

  onDeletePhoto = () => {
    //console.log("in onDeletePhoto, this.state.Photos=", this.state.Photos,"this.state.photoItem=",this.state.photoItem,"this.state.index=",this.state.index);
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    var removeOrder = this.state.photoItem.order;
    var photos = this.state.Photos;
    var index = this.state.index;
    photos.splice(index, 1);
    //console.log("in onDeletePhoto, photos=", photos);
    //for (var i = 0; i < photosLength; i++) {
    for (var i = 0; i < photos.length; i++) {
      if (photos[i].order > removeOrder) photos[i].order = photos[i].order - 1;
    }
    this.setState({ Photos: photos });
    window.$("#" + this.state.photoItem.photoID).remove();
    if (this.state.photoItem.photoID2) {
      window.$("#" + this.state.photoItem.photoID2).remove();
    }
    this.doBindSortable();
  };

  handleRemoveFileClick = (id) => {
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    var photos = this.state.Photos;
    var index = -1;
    for (var i = 0; i < photosLength; i++) {
      if (photos[i].photoID == id || photos[i].photoID2 == id) {
        index = i;
      }
    }
    if (index > -1) {
      var photoItem = photos[index];

      this.setState({ Photos: photos });
      this.setState({ photoItem: photoItem });
      this.setState({ index: index });
      let title = "Delete photo?";
      let body = "Do you want to delete photo now? This cannot be undone.";
      let callback = this.onDeletePhoto;
      this.showPopupAndDeleteOnConfirmation(title, body, callback);
    }
  };

  handleEditFileClick = (id) => {
    console.log(id);
    var photoItem = this.selectPhotoByID(id);
    if (photoItem != null) {
      this.setState({ m_Index: id, m_Description: photoItem.description });
      window.$("#PhotoUploadModal").modal("show");
    }
  };

  onSaveDescriptionClick = () => {
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    var photos = this.state.Photos;
    var index = -1;
    for (var i = 0; i < photosLength; i++) {
      if (photos[i].photoID == this.state.m_Index || photos[i].photoID2 == this.state.m_Index) {
        index = i;
        break;
      }
    }
    console.log(index);
    if (index > -1) {
      photos[index].description = this.state.m_Description;
      this.setState({ Photos: photos });
      window.$("#desc" + photos[index].photoID).html(photos[index].description == "" ? "no description added" : photos[index].description);
      if (photos[index].photoID2) {
        window.$("#desc" + photos[index].photoID2).html(photos[index].description == "" ? "no description added" : photos[index].description);
      }
    }
    window.$("#PhotoUploadModal").modal("hide");
  };

  onRotateImageClick = (id, clockwise) => {
    var photoItem = this.selectPhotoByID(id);
    if (photoItem !== undefined && photoItem != null) {
      var degrees = parseInt(window.$("#img" + photoItem.photoID).data("degrees"), 10);
      var current_degrees = degrees;

      if (clockwise == "true") {
        degrees = (degrees - 90) % 360;
      } else {
        degrees = (degrees + 90) % 360;
      }

      if (degrees == -0) degrees = 0;

      if (photoItem.photoID.indexOf("NAP") > -1) {
        this.drawRotatedImage(photoItem, degrees);
      } else {
        window.$("#img" + photoItem.photoID).data("degrees", degrees);
        var img = document.getElementById("img" + photoItem.photoID);
        img.className = "img-view rotate" + degrees;
      }
    }
  };

  drawRotatedImage = (photoItem, degrees) => {
    var canvas = document.createElement("CANVAS");
    var image = new Image();
    image.onload = function () {
      var width = image.width;
      var height = image.height;
      if (degrees == 90 || degrees == -90 || degrees == 270 || degrees == -270) {
        width = height;
        height = width;
      }
      canvas.width = width;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.translate(width / 2, height / 2);
      ctx.rotate((degrees * Math.PI) / 180);
      ctx.drawImage(image, -width / 2, -height / 2);
      ctx.restore();
      var dataURL = canvas.toDataURL("image/jpeg", 1.0);
      var photos = this.state.Photos;
      var index = photos.indexOf(photoItem);
      if (index > -1) {
        photos[index]["Rotate"] = degrees;
        window.$("#img" + photos[index].photoID).data("degrees", degrees);
        window.$("#img" + photos[index].photoID).attr("src", dataURL);
        this.setState({ Photos: photos });
      }
    }.bind(this);
    image.src = photoItem.dataUrl;
  };

  selectPhotoByID = (id) => {
    var photos = this.state.Photos;
    var photosLength = this.state.Photos ? this.state.Photos.length : 0;
    var index = -1;
    for (var i = 0; i < photosLength; i++) {
      if (photos[i].photoID == id || photos[i].photoID2 == id) {
        index = i;
      }
    }
    if (index > -1) {
      return photos[index];
    }
    return null;
  };

  setOrderText = () => {
    if (this.state.Photos !== undefined && this.props.super_access) {
      this.state.Photos.forEach(function (element) {
        window.$("#spanOrder" + element.photoID).html(element.order + ")");
      }, this);
    }
  };

  onLinkComponentChange = (links) => {
    //console.log("onLinkComponentChange, links=", links);
    this.setState({ Links: links });
  };

  onFileComponentChange = (files, fileCollection) => {
    //console.log("onFileComponentChange", files);
    this.setState({ Files: files });
  };

  onChangeExpand = (e) => {
    var photo_expanded = !this.state.photo_expanded;
    this.setState({ photo_expanded: photo_expanded });
  };

  handleAddExternalLinkClick = (e) => {
    this.linkComponentRef.current.handleAddExternalLinkClick(e);
  };

  handleAddFilesClick = (e) => {
    this.fileComponentRef.current.handleAddFilesClick(e);
  };

  handleZoomClick = (step) => {
    //console.log("inside handleZoomClick", step);
    var ViewZoom = this.state.ViewZoom;
    if (step == -1) {
      if (ViewZoom == 30) return;

      ViewZoom = ViewZoom - 10;
    } else {
      if (ViewZoom == 100) return;

      ViewZoom = ViewZoom + 10;
    }

    this.setState({ ViewZoom: ViewZoom }, function () {
      window.$(".media-img-box").each(function (index, element) {
        window
          .$(element)
          .removeClass(
            "media-img-box-30 media-img-box-40 media-img-box-50 media-img-box-60 media-img-box-70 media-img-box-80 media-img-box-90 media-img-box-100"
          )
          .addClass("media-img-box-" + ViewZoom);
      });
      this.doBindSortable();
    });
  };

  state = this.getStateFromData(this.props.data);

  render() {
    //console.log("inside render of mediaStepView, state=",this.state);
    return (
      <div>
        <ConfirmationModalPopup {...this.state.confirmationModalProps} />
        <div className="row">
          <div className="col-md-6 col-sm-12">
            <div className="form-group">
              <span>Media files are made available on websites.</span>
            </div>
          </div>
          <div className="col-md-6 col-sm-12">
            <div className="form-group pull-right">
              <a
                href="javascript:void(0);"
                style={{ cursor: "pointer", marginRight: 10, marginTop: 5 }}
                className="btn btn-success-oms"
                onClick={this.handleAddFilesClick}
              >
                Add files
              </a>
              <a
                href="javascript:void(0);"
                style={{ cursor: "pointer", marginRight: 10, marginTop: 5 }}
                className="btn btn-success-oms"
                onClick={this.handleAddExternalLinkClick}
              >
                Add external links
              </a>
              <a href="javascript:void(0);" style={{ cursor: "pointer", marginTop: 5 }} className="btn btn-success-oms" onClick={this.handleAddPhotosClick}>
                Add photos
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <MediaFileComponent
            ref={this.fileComponentRef}
            data={this.state.Files}
            propertyID={this.props.data.propertyID}
            onChange={this.onFileComponentChange}
            officeSyncID={this.props.officeSyncID}
          />
          <MediaLinkComponent ref={this.linkComponentRef} data={this.state.Links} onChange={this.onLinkComponentChange} />

          <div className="panel panel-default">
            <div className="panel-heading" style={{ cursor: "pointer" }} onClick={this.onChangeExpand}>
              <div className="row">
                <div className="col-md-12">
                  <a style={{ cursor: "pointer", display: "inline-block", paddingTop: 5 }}>
                    <i className={this.state.photo_expanded ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                  </a>
                  <span style={{ marginLeft: 10, fontWeight: "bold" }}>Photos ({this.state.Photos ? this.state.Photos.length : 0})</span>
                </div>
              </div>
            </div>
            <div className="panel-body">
              <input
                type="file"
                id="uploadPhoto"
                name="uploadPhoto"
                accept="image/*"
                style={{ display: "none" }}
                onChange={this.handleUploadFileChange}
                multiple={true}
              />
              <div style={{ display: this.state.photo_expanded ? "" : "none" }}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="pull-right" style={{ marginBottom: 10 }}>
                      {this.state.ViewZoom == 30 ? (
                        <span style={{ color: "grey" }}>
                          <i className="fa fa-minus-circle"></i>
                        </span>
                      ) : (
                        <a href="javascript:void(0);" style={{ cursor: "pointer" }}>
                          <i className="fa fa-minus-circle" onClick={() => this.handleZoomClick(-1)}></i>
                        </a>
                      )}
                      <span style={{ marginLeft: 10, marginRight: 10, display: "inline-block" }}>
                        <b>{this.state.ViewZoom}%</b>
                      </span>
                      {this.state.ViewZoom == 100 ? (
                        <span style={{ color: "grey" }}>
                          <i className="fa fa-plus-circle"></i>
                        </span>
                      ) : (
                        <a href="javascript:void(0);" style={{ cursor: "pointer" }}>
                          <i className="fa fa-plus-circle" onClick={() => this.handleZoomClick(1)}></i>
                        </a>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div id="js-grid" className="js-grid" onClick={this.handleOnMainPhotoContainerClick}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="PhotoUploadModal" className="modal fade" tabIndex={-1} role="dialog" aria-labelledby="PhotoUploadModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-hidden="true">
                    ×
                  </button>
                  <h4 className="modal-title" id="PhotoUploadModalLabel">
                    Photo description
                  </h4>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label htmlFor="m_Description">Description</label>
                      <textarea
                        rows={2}
                        className="form-control"
                        id="m_Description"
                        name="m_Description"
                        value={this.state.m_Description}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <OMSButtonStyleL
                    type="button"
                    style={{ marginRight: 10 }}
                    ui_icon="fa-check"
                    ui_type="save"
                    ui_text="Save"
                    ui_processing_text="Saving.."
                    processing={false}
                    disabled={false}
                    onClick={this.onSaveDescriptionClick}
                  />
                  <button type="button" className="btn btn-default" data-dismiss="modal">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="ImageModal1" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog" style={{ width: "80%", maxWidth: "860px", maxHeight: "660px" }}>
              <div className="modal-content">
                <div className="modal-body">
                  <button type="button" className="close" data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                    <span className="sr-only">Close</span>
                  </button>
                  <img src="" id="imgPre" className="imgPre" style={{ width: "100%" }} />
                </div>
              </div>
            </div>
          </div>
          <div id="ImageModal2" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true">
            <div id="ImageModal2Dialog" className="modal-dialog" style={{ width: "80%", height: "80%", maxWidth: "550px", maxHeight: "550px" }}>
              <div className="modal-content">
                <div id="ImageModal2Body" className="modal-body">
                  <button type="button" className="close" data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                    <span className="sr-only">Close</span>
                  </button>
                  <img src="" id="imgPre2" className="imgPre2" style={{ width: "100%", height: "100%", maxWidth: "512px", maxHeight: "512px" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
